<template>
	<div class="activation-code-vue">
		<h1>
			Dodajte interaktivno gradivo z aktivacijsko kodo
			<i class="circular red help icon popup" id="openVideoHelpPopup" ref="help" v-on:click="openHelp" data-html="<p>Aktivacijska koda je navedena na notranji strani naslovnice gradiva ali na priloženem kartončku.</p><p>Po aktivaciji dostopa boste v tem šolskem letu do interaktivnega gradiva dostopali brezplačno.</p>" data-variation="wide"></i>
		</h1>
		<p>V polje vpišite aktivacijsko kodo.</p>
		<p>Pomembno: Gradiva Lili in Bine so dostopna samo na portalu <a v-bind:href="lilibiUrl" target="_blank">lilibi.si</a>. Za aktiviranje dostopa kliknite <a v-bind:href="lilibiUrl + '/aktivacija'" target="_blank">tukaj</a>.</p>
		
		 <form id="mainForm" class="ui form" method="post" v-bind:class="{error: error}">

		 	<div class="two fields">
		 		<div class="field" v-bind:class="{error: error}">
		 			<div class="ui input">
		 				<input v-model="activationCode" type="text" name="code" placeholder="Aktivacijska koda" />
		 			</div>
		 			<div class="ui basic red pointing prompt label transition visible" v-if="error">{{error}}</div>
		 		</div>
		 	</div>

		 	<div class="field ui">
		 		<button v-on:click="goBack" name="back" class="ui button" tabindex="4">Nazaj</button>
				<button v-on:click="submit" type="submit" name="submit" value="submit" class="ui submit yellow button" v-bind:class="{disabled: !enableSubmit}" tabindex="13" >Potrdi</button>
			</div>

		 </form>
	</div>
</template>

<script>
	import successModal from '../modals/ActivationCodeSuccess.vue'
	import helpModal from '../modals/ActivationCodeHelp.vue'

    export default {
    	data() {
    		return {
    			lilibiUrl: process.env.MIX_LILIBI_URL,
    			activationCode: null,
    			enableSubmit: false,
    			error: null
    		}
    	},
    	mounted() {
    		$(this.$refs['help']).popup();
        },
        methods: {
        	goBack(event) {
        		window.location.href = this.route('izbirka');
        		event.preventDefault();
        	},
        	submit(event) {
        		axios.post(this.route('aktivacijska-koda'), {
				    code: this.activationCode,
			  	}).then((response) => {
			  		let data = response.data;
			  		if (data.status == 'fail') {
			  			switch (data.message) {
			  				case 'activation_code_invalid':
			  					this.error = 'Aktivacijska koda ni veljavna.';
			  					break;
			  				case 'activation_code_used':
			  					this.error = 'Aktivacijska koda je že uporabljena.';
			  					break;
			  				case 'wrong_app':
			  					this.error = 'Aktivacijska koda uporabljena na napačnem portalu.';
			  					break;
			  			}
			  		} else {
			  			this.$root.$emit('add-popup', successModal);
			  		}
			  	});
			  	event.preventDefault();
        	},
        	openHelp() {
        		this.$root.$emit('add-popup', helpModal);
        	}
        },
        watch: {
        	activationCode(newValue, oldValue) {
        		this.error = null;
    			this.enableSubmit = this.activationCode.length > 0
        	}
        },
        computed: {
        	
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ActivationCode.vue